// libs
import { Record } from "immutable";
import MenuLunch from "./MenuLunch";
import MenuSweets from "./MenuSweets";
import MenuDrink from "./MenuDrink";


const BaseRecord = Record({
  lunch: new MenuLunch(),
  sweets: new MenuSweets(),
  drink: new MenuDrink()
});

export default class MenuCollection extends BaseRecord {
  init(data) {
    let lunch = new MenuLunch();
    let sweets = new MenuSweets();
    let drink = new MenuDrink();

    data.forEach((item) => {
      if (item.id === "lunch") {
        lunch = lunch.init(item);
      } else if (item.id === "sweets") {
        sweets = sweets.init(item);
      } else if (item.id === "drink") {
        drink = drink.init(item);
      }
    });

    return this.withMutations(s =>
      s.set("lunch", lunch)
       .set("sweets", sweets)
       .set("drink", drink)
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/models/MenuCollection.js